import { withRouter } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import medpassService from "../services/emar-medpass-service";
import cogoToast from "cogo-toast";
import { Multiselect } from "multiselect-react-dropdown";
import Loader from "react-loader-spinner";
import { selectUsers } from "../state/reducers/userSlice";
import { selectPatient, clearSelectedPatient } from "../state/reducers/emarSlice";
import React, { useEffect, useState, createRef } from "react";
import moment from "moment";
import LEFT_ARROW from "../assets/img/Left_Arrow.svg";
import RIGHT_ARROW from "../assets/img/Right_Arrow.svg";
import RIGHT_ARROW_INACTIVE from "../assets/img/Right_Arrow_Inactive.svg";
import emarMedpassService from "../services/emar-medpass-service";
import DOWNLOAD from "../assets/img/download.png";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const MedpassHistory = ({ history }) => {
  const multiselectRef = createRef();
  const { user } = useSelector(selectUsers);
  const { selectedPatient } = useSelector(selectPatient);
  const [patientsList, setPatientsList] = useState([]);
  const [patSelected, setPatSelected] = useState({});
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(new Date());
  const [historyData, setHistoryData] = useState([]);
  const [duration, setDuration] = useState();
  const dispatchEmar = useDispatch();
  async function getPatHistory() {
    try {
      setLoading(true);
      setHistoryData([]);
      let resp = await medpassService.getEmarPatientHistoryInfo(user?.facility, patSelected.pat_id, moment(date).format("MM/DD/YYYY"));
      if (resp === "no content to show") {
        setLoading(false);
        const { hide } = cogoToast.error(
          "No Administered Medications Found For Selected Patient and Date",
          {
            hideAfter: 4,
            onClick: () => {
              hide();
            },
          }
        );
        return;
      }
      setHistoryData(resp);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  }

  const getPatients = async () => {
    try {
      setLoading(true);
      let resp = await emarMedpassService.getEmarPatientInfo(user?.facility, moment(date).format("MM/DD/YYYY"));
      if (resp) {
        setPatientsList(resp);
        if (selectedPatient?.length > 0) {
          let patSelected = resp.filter((item) => item.id === selectedPatient.pat_id);
          setPatSelected(patSelected);
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  useEffect(() => {
    getPatients();
    return function cleanup() {
      dispatchEmar(clearSelectedPatient());
    }
  }, []);

  useEffect(() => {
    if (selectedPatient?.pat_id)
      setPatSelected(selectedPatient)
  }, [selectedPatient]);

  useEffect(() => {
    setDuration(new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate());
  }, [date]);

  useEffect(() => {
    if (patSelected?.pat_id && date)
      getPatHistory();
  }, [patSelected, date]);
 
  const handleDownload = async (htmlString) => {
    if (!loading) {
      setLoading(true);
      const domElement = document.querySelector('#patHistory')
      html2canvas(domElement, {
        onclose: (document) => {
          document.querySelector('#save-button').style.visibility = 'hidden'
        }
      })
        .then((canvas) => {
          const imgData = canvas.toDataURL('image/jpeg')
          const pdf = new jsPDF('l', 'mm', 'a4');
          pdf.addImage(imgData, 'JPEG', 5, 5, 280, 90)
          pdf.save('MedpassHistory.pdf');
          setLoading(false);
        })
    }
  };
  


  const handleNavigation = async (id) => {
    try {
      await history.push("/medpass");
    } catch (e) {
      setLoading(false);
    }
  };
    return (
    <>
      <CipHeader />

      <div className="bg-white w-11/12 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/3 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">MEDICATION HISTORY (MAR)</span>
          </div>
          <div className="w-2/3 sm:w-3/4 text-right font-semibold ">
              <span className="inline-block align-middle mr-2 cursor-pointer" onClick={() => {
                handleDownload(patSelected?.pat_id, date)

              }}>
                <img
                  className="  h-9 w-9"
                  alt=""
                  src={DOWNLOAD}
                />
              </span>
            <span className="inline-block align-middle cursor-pointer" onClick={() => {
              let prev = moment(date).subtract(1, 'months');
              setDate(new Date(moment(prev).format('MM/DD/YYYY')));
            }}>
              <img
                className="  h-9 w-9"
                alt=""
                src={LEFT_ARROW}
              />
            </span>
            <span className="inline-block mr-6 ">
              <div>
                <DatePicker
                  placeholderText="MM/DD/YYYY"
                  selected={date}
                  dateFormat="MMM y"
                  showMonthYearPicker
                  onChange={(date) => {
                    setDate(moment(date, "MM-DD-YYYY").toDate());
                  }}
                  className="border focus:outline-none h-11 bg-header_bg text-white rounded-md pl-2 font-normal   text-sm"
                />
              </div>
            </span>
              {new Date().getMonth() !== date.getMonth() ? <span className="inline-block align-middle ml-2" onClick={() => {
                let next = moment(date).add(1, 'months');
                setDate(new Date(moment(next).format('MM/DD/YYYY')))
              }}>
                <img
                  className="align-bottom  h-9 w-9 cursor-pointer"
                  alt=""
                  src={RIGHT_ARROW}
                />
              </span> : <span className="inline-block align-middle ml-2" >
                <img
                  className="align-bottom  h-9 w-9"
                  alt=""
                  src={RIGHT_ARROW_INACTIVE}
                />
              </span>}
            <span className="w-1/4 inline-block mr-4 pl-4 min-w-1/2">
              <Multiselect
                name="patient"
                displayValue="pat_name"
                options={patientsList}
                selectedValues={patSelected?.pat_id ? [patSelected] : []}
                ref={multiselectRef}
                closeOnSelect={true}
                placeholder="Select Patient"
                onSelect={(selectedList, selectedItem) => {
                  setPatSelected(selectedItem);
                }}
                onRemove={(e) => {
                  setPatSelected({});
                }}
                selectionLimit={1}
              />
            </span>
              <span className="w-1/4  mr-4 pl-2">
               {user?.userRole !== 'PROVIDER' && <button
                  className=" rounded font-medium h-10 text-white w-auto px-3 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
                  onClick={() => handleNavigation()}>Go to Medpass administration</button> }
              </span>
          </div>
        </div>
        <div id="patHistory" className="p-2 mt-3 ">
          <div className="w-full flex justify-end ">
            <div className="emarAdministeredImg"> </div>
            <span className="text-semibold text-sm 	ml-2 font-semibold	mr-6">Administered</span>
            <div className="emarSelfAdministeredImg"> </div>
            <span className="text-semibold text-sm 	ml-2 font-semibold	mr-6">Self Administered</span>
            <div className="emarNotAdministeredImg"> </div>
            <span className="text-semibold text-sm	ml-2 font-semibold	mr-6">Not Administered</span>
            <div className="emarRefusedImg"> </div>
            <span className="text-semibold text-sm	ml-2 font-semibold	mr-6">Refused</span>
            <div className="emarHoldImg"> </div>
            <span className="text-semibold text-sm 	ml-2 font-semibold	mr-6">On Hold</span>
            <div className="emarDiscontinueImg"> </div>
            <span className="text-semibold text-sm 	ml-2 font-semibold	mr-6">Discontinue</span>
            <div className="emarNoShowImg"> </div>
            <span className="text-semibold text-sm 	ml-2 font-semibold	mr-6">No Show</span>
          </div>
          <div
            className={`inline-block customtop absolute   z-50 ${loading ? "show" : "hidden"
              }`}
          >
            <Loader
              type="Oval"
              color="#00BFFF"
              height={50}
              width={50}
              timeout={300000} //3 secs
            />
          </div>
          {Object.keys(patSelected).length > 0 && <div className={`grey  flex   rounded-3xl   flex-auto `}>
            <div className="mr-4">
              <img
                className="rounded-full w-16 h-16"
                alt=""
                src={patSelected?.profile_pic}
              />
            </div>
            <div className="pt-3">
              <div className="w-1/50">
                <span className="text-2xl font-semibold">
                  {patSelected?.pat_name}{" "}
                </span>
                <span className="text-xl font-semibold">
                  {patSelected?.pat_acct_nubmer} {"   "}
                </span>
                <span className="text-sm font-semibold">{patSelected?.pat_gender} </span>.
                <span className="text-sm font-semibold"> {patSelected?.pat_age} </span>.
                <span className="text-sm font-semibold">
                  {" "}
                  DOB : {moment.utc(patSelected?.pat_dob).format("MM/DD/YYYY")}
                </span>
              </div>


            </div>
          </div>}

          {Object.keys(patSelected).length > 0 && <div className="w-full">
            <table className="  mt-8 w-full leading-normal">
              <thead className="w-full">
                <tr className="w-full ">
                  <th className="w-96"></th>
                  <th className="w-1/50">1</th>
                  <th className="w-1/50">2</th>
                  <th className="w-1/50">3</th>
                  <th className="w-1/50">4</th>
                  <th className="w-1/50">5</th>
                  <th className="w-1/50">6</th>
                  <th className="w-1/50">7</th>
                  <th className="w-1/50">8</th>
                  <th className="w-1/50">9</th>
                  <th className="w-1/50">10</th>
                  <th className="w-1/50">11</th>
                  <th className="w-1/50">12</th>
                  <th className="w-1/50">13</th>
                  <th className="w-1/50">14</th>
                  <th className="w-1/50">15</th>
                  <th className="w-1/50">16</th>
                  <th className="w-1/50">17</th>
                  <th className="w-1/50">18</th>
                  <th className="w-1/50">19</th>
                  <th className="w-1/50">20</th>
                  <th className="w-1/50">21</th>
                  <th className="w-1/50">22</th>
                  <th className="w-1/50">23</th>
                  <th className="w-1/50">24</th>
                  <th className="w-1/50">25</th>
                  <th className="w-1/50">26</th>
                  <th className="w-1/50">27</th>
                  <th className="w-1/50">28</th>
                  {duration > 28 && <th className="w-1/50">29</th>}
                  {duration > 29 && <th className="w-1/50">30</th>}
                  {duration > 30 && <th className="w-1/50">31</th>}
                </tr>
              </thead>
              <tbody className="pt-3">
                {historyData?.map(((medi, index) => {
                  return (
                    <>
                      <tr className="" key={medi.drG_ID + index + (Math.random() * 4.29) + medi.drG_DNAME + 'Emar'}>

                        <td colSpan="30" className="text-lg text-left pr-4 pt-4 font-semibold">{medi?.drG_DNAME}
                          <div className="text-sm">{medi?.rxF_SIG}  </div>
                          <div className="text-sm">{medi?.rxF_ORG_DATE &&  `${'Start date: ' + moment.utc(medi?.rxF_ORG_DATE).format('MM/DD/YYYY')}`}   {medi?.rxF_EXP_DATE &&  `${'Stop date: ' + moment.utc(medi?.rxF_EXP_DATE).format('MM/DD/YYYY')}`}</div>
                          {medi?.is_stat_med && <div className="text-sm">STAT</div>}
                        </td>
                      </tr>
                      {medi?.ranges.map(item => {
                        return (
                          <tr className="" key={item.range + (Math.random() * 2.249) + 'Emar'}>
                            <td className="text-base text-right pr-4 pt-2 font-normal">{item.range}</td>
                            {item?.status.map(dates => {
                              let title = "";
                              if (dates.administer_fname) {
                                title += "Nurse : " + dates.administer_fname + ' ' + dates.administer_lname + '\n';
                              }
                              if (dates.administered_at) {
                                title += "Date : " + moment(dates.administered_at).format('MM-DD-YYYY HH:mm:ss') + '\n';
                              }
                              if (dates.blood_sugar) {
                                title += "Blood Sugar : " + dates.blood_sugar + '\n';
                              }
                              if (dates.diastolic) {
                                title += "Diastolic : " + dates.diastolic + '\n';
                              }
                              if (dates.systolic) {
                                title += "Systolic : " + dates.systolic + '\n';
                              }
                              if (dates.heart_rate) {
                                title += "Heart Rate : " + dates.heart_rate + '\n';
                              }
                              if (dates.units_inj) {
                                title += "Units Injected : " + dates.units_inj + '\n';
                              }
                              if(dates.medpass_status === 'K' || dates.medpass_status === 'P'){
                                title += "Qty given: " + dates.dose_taken_qty + '\n';
                              }
                              let curDate = moment().format('MM/DD/YYYY');
                              let medDate = moment(dates.med_date).format('MM/DD/YYYY');
                              let isBefore24Hours = moment(medDate).isBefore(moment(curDate).subtract(24, 'hours'));
                              return (
                                <td key={dates?.medpass_status + (Math.random() * 1.4296) + title + `${dates?.is_disabled}` + 'Emar'} title={title} className="text-center pt-2   ">
                                  <div className={`
                                  ${ (moment(medDate).isAfter(curDate) || dates?.medpass_status === null) ? "bg-slate" : (dates?.medpass_status === "A" || dates?.medpass_status === "P" || dates?.medpass_status === "K")
                                      ? "emarAdministeredImg cursor-pointer mx-auto"
                                   : dates?.medpass_status === "S"
                                    ? "emarSelfAdministeredImg cursor-pointer mx-auto"
                                  : dates?.medpass_status === "H"
                                    ? "emarHoldImg cursor-pointer mx-auto"
                                   : (dates?.medpass_status === "C" || (dates?.medpass_status === '' && isBefore24Hours) )
                                    ? "emarNoShowImg cursor-pointer mx-auto"
                                  : dates?.medpass_status === "DC"
                                    ? "emarDiscontinueImg cursor-pointer mx-auto"
                                  : dates?.medpass_status === "N"
                                    ? "emarNotAdministeredImg cursor-pointer mx-auto"
                                    : (dates?.medpass_status === "R" || dates?.medpass_status === "D")
                                      ? "emarRefusedImg cursor-pointer mx-auto"
                                      : "  shadow-sm mt-1 inline-block w-2  mb-1 border-2"
                                  }`}> </div></td>)
                            })}
                          </tr>
                        )
                      })}
                    </>
                  )
                }))}
              </tbody>
            </table>
          </div>}
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(MedpassHistory)
);